<template>
  <div>
    <!-- Main flex -->
    <main class="grid grid-cols-2 lg:grid-cols-5 mx-auto max-w-screen-xl mt-6 gap-4 px-4 lg:px-0">
      <!-- Viewport -->
      <div class="lg:col-span-3 col-span-2 lg:order-1">
        <presenter-viewport ref="viewport" @create-take-folder="$refs.videoTakeList.showCreateFolderModal = true"
                            :roomKey="'A'"
                            :slides="slides"
                            :selected-anim="selectedAnim"
                            v-bind:current-slide-index.sync="currentSlideIndex"
                            :isLowDataModeOn="isLowDataModeOn" :room-activated="true"></presenter-viewport>
      </div>
      <!-- Slides -->
      <div class="lg:col-span-1 order-6 lg:order-3 flex flex-col space-y-4 h-64 xl:h-128" style="height: 33rem;">
        <slides-manager ref="slides" :slides="slides" v-bind:current-slide-index.sync="currentSlideIndex"> </slides-manager>
      </div>
      <!-- Participants  -->
      <div class="lg:col-span-1 order-6 lg:order-3 flex flex-col space-y-4 h-64 xl:h-128" style="height: 33rem;">
        <div class="flex text-base justify-between">
          <div class="text-lg font-medium">
            Participants
          </div>
        </div>
        <participant-list ref="participantList" class="flex-grow" style="height: 26rem"></participant-list>
      </div>

      <!-- Media -->
      <div class="lg:col-span-3 order-6 lg:order-3 flex flex-col space-y-4 h-64 xl:h-128" style="height: 33rem;">
        <media-manager></media-manager>
      </div>
      <div class="lg:col-span-2 order-6 lg:order-4 flex flex-col space-y-4 h-64 xl:h-128" style="height: 33rem;">
        <pinboard :presentation-id="presentationId" :p-key="participant_key" :role="'guest'"></pinboard>
      </div>
    </main> <!-- MainFlex END -->
    <!-- Tasks (this shows stuff like connecting to server) -->
    <div class="fixed right-0 bottom-0 px-5 py-5 bg-white shadow-lg border rounded-md status-indicator z-40">
      <div class="tasks"></div>
    </div>
    <modal :showModal="showPermissionModal" @close="showPermissionModal = false">
      <div v-show="permissionStep == 1">
        <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
          <!-- Upload cloud icon -->
          <svg class="h-6 w-6 text-green-600 fill-current" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
               viewBox="0 0 24 24">
            <path fill-rule="evenodd"
                  d="M11 4C8.79082 4 7 5.79085 7 8C7 8.03242 7.00047 8.06627 7.00131 8.10224C7.01219 8.56727 6.70099 8.97839 6.25047 9.09416C4.95577 9.42685 4 10.6031 4 12C4 13.6569 5.34317 15 7 15H8C8.55228 15 9 15.4477 9 16C9 16.5523 8.55228 17 8 17H7C4.23861 17 2 14.7614 2 12C2 9.93746 3.2482 8.16845 5.02926 7.40373C5.32856 4.36995 7.88746 2 11 2C13.2236 2 15.1629 3.20934 16.199 5.00324C19.4207 5.10823 22 7.75289 22 11C22 14.3137 19.3138 17 16 17C15.4477 17 15 16.5523 15 16C15 15.4477 15.4477 15 16 15C18.2092 15 20 13.2091 20 11C20 8.79085 18.2092 7 16 7C15.8893 7 15.78 7.00447 15.6718 7.01322C15.2449 7.04776 14.8434 6.8066 14.6734 6.4135C14.0584 4.99174 12.6439 4 11 4ZM11.2929 9.29289C11.6834 8.90237 12.3166 8.90237 12.7071 9.29289L14.7071 11.2929C15.0976 11.6834 15.0976 12.3166 14.7071 12.7071C14.3166 13.0976 13.6834 13.0976 13.2929 12.7071L13 12.4142V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V12.4142L10.7071 12.7071C10.3166 13.0976 9.68342 13.0976 9.29289 12.7071C8.90237 12.3166 8.90237 11.6834 9.29289 11.2929L11.2929 9.29289Z"
                  clip-rule="evenodd"/>
          </svg>
        </div>
        <div class="mt-3 text-center sm:mt-5">
          <h3 class="text-lg leading-6 font-medium text-gray-900" id="permission-modal-headline">
            Welcome to Presenter.
          </h3>
          <div class="mt-2">
            <p class="text-sm text-gray-500">
              Before you begin, we need to get access to your microphone and camera.
            </p>
          </div>
        </div>
        <div class="text-center mt-5" id="requestMediaPermissionsWrapper">
          Microphone is <span id="micPermissionStatus" class="text-sm"></span>
          &bull;
          Camera is <span id="videoPermissionStatus" class="text-sm"></span>
        </div>
        <div class="mt-5 space-x-2 text-center">
          <button class="btn btn-sm btn-secondary text-sm" @click="requestMediaPermissions" v-show="!permissionGranted">
            Request permissions
          </button>
        </div>
      </div>
      <div v-show="permissionStep == 2">
        <div class="text-2xl font-bold">
          Settings review
        </div>
        <div class="text-base font-semibold mt-4">
          Host microphone
        </div>
        <select class="audioSource form-input w-full" data-id="0"></select>

        <div class="flex flex-wrap mt-4">
          <div class="text-base font-semibold">
            Host headphones
          </div>
        </div>
        <div class="flex flex-wrap items-baseline justify-between">
          <select class="audioOutput form-input flex-1 mr-2" data-id="0"></select>
          <audio src="/audio/test_audio.mp3" id="headphoneTestAudio"></audio>
        </div>

        <div class="text-base font-semibold mt-4">
          Camera video source
        </div>
        <select class="videoSource form-input w-full" data-id="0"></select>
        <p class="mt-4">
          Remember that we use a PTT to keep everything tidy. Please use it to speak to your guests.
        </p>
        <br/>
        <button class="btn btn-primary w-full" @click="showPermissionModal = false">Everything looks ok</button>
      </div>
    </modal>
  </div>
</template>
<script>
import axios from "axios";
import {detectBrowser} from 'utils/browser';
import {requestMediaPermissions, checkAVPermissions, refreshDevices} from 'webrtc/mediaDevices';
import messageBroker from 'general/messageBroker';
import commandsManager from 'general/CommandsManager'
import {localNotify} from "utils/notifications";

export default {
  name: 'presenter-role-host',
  props: {
    room: {},
    presentationId: {
      type: Number,
      required: true
    },
    roles: {
      type: Array
    },
    name: {},
    activeUntil: {
      type: Number
    },
  },
  data() {
    return {
      resolution: '360p',
      participant_key: participant_key,
      microphoneSelected: '',
      heapdhonesSelected: '',
      cameraSelected: '',
      constraints: {},

      permissionGranted: null,
      permissionStep: 1,
      showPermissionModal: false,
      permissionsNeeded: {
        audio: true,
        video: true
      },
      token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      //Slides management
      currentSlideIndex: 0,
      slides: [],
      selectedAnim: '',
    }
  },
  mounted() {
    console.log("Starting presenter role host")
    window.refreshDevices = refreshDevices;

    // START WEBRTC
    setupEngine('presenter', 'presenter');
    joinSession(this.room.key);

    // check if browser is compatible
    this.checkBrowser();
    // set the warning message before unload ("You are leaving this site")
    // setBeforeUnload();

    checkAVPermissions({
      microphone: true,
      camera: true,
    }).then((granted) => {
      // this.showPermissionModal = !granted;
      this.permissionGranted = granted;
      this.showPermissionModal = true;
      this.permissionStep = granted ? 2 : 1;
    });


    window.role = 'presenter'
    window.authenticity_token = this.authenticity_token
    window.room = this.room.key
    window.product = 'presenter'
    window.room_key = this.room.key
    window.name = this.name
    window.activeUntil = self.activeUntil

    // Enable participant list connections
    // Taken from startTimer func from mirror-host
    // this.$refs.participantList.showActions = true;
    this.loadSlides();

    commandsManager.registerNewCommand('slide_changed', (data) => {
      this.currentSlideIndex = data.args;
    }); 
    commandsManager.registerNewCommand('animation_changed', ({args: {selectedAnim}}) => {
      this.selectedAnim = selectedAnim
    })
  },
  methods: {
    sendSlides(peerId){
      messageBroker.sendCommand('init_presentation', peerId, this.slides);
      setTimeout(() => {
        messageBroker.sendCommand('slide_changed', peerId, this.currentSlideIndex)   
      }, 1000);
    },
    requestMediaPermissions() {
      requestMediaPermissions(this.permissionsNeeded)
          .then(() => {
            this.permissionGranted = true;
            window.location.reload();
          })
          .catch(() => {
            //    alert("Error getting permissions");
          });
    },
    checkBrowser() {
      if (detectBrowser(window).browser === 'chrome' && detectBrowser(window).version >= 81
          // disabling firefox support
          // || (detectBrowser(window).browser == 'firefox' && detectBrowser(window).version >= 78)
      ) {
        // place only chrome stuff here
      } else {
        $("#browserNotCompatible").removeClass("hidden")
        $("#browserName").html(detectBrowser(window).browser + " " + detectBrowser(window).version)
      }
    },
    loadSlides(){
      let url = '/presentation/' + this.presentationId + '/slides';
      axios.get(url).then(response => {
        response.data.forEach(x => {
          let slide = {};
          slide.media_id = x.medium.id;
          slide.media_type = x.medium.media_type;
          slide.order = x.order;
          slide.posInEditor = x.order;
          slide.url = x.medium.url;
          slide.name = x.name;
          this.slides.splice(x.order, 1, slide);
        });
      }).catch(response => {});
    },
  }
}
</script>
